<mat-sidenav-container class="glxy-page-nav-container" [hasBackdrop]="false">
  <mat-sidenav
    #pageNav
    class="glxy-page-nav"
    [mode]="mobileQuery.matches ? 'over' : 'side'"
    [opened]="!mobileQuery.matches"
    [ngClass]="{ 'full-screen': mobileQuery.matches }"
  >
    <ng-content select="glxy-nav-layout"></ng-content>
  </mat-sidenav>
  <mat-sidenav-content class="glxy-page-nav-content">
    <button mat-stroked-button class="glxy-page-nav-toggle" *ngIf="mobileQuery.matches" (click)="togglePageNav()">
      <mat-icon>menu_open</mat-icon>
      {{ toggleLabel || 'GALAXY.PAGE_NAV.TOGGLE_LABEL' | translate }}
    </button>
    <ng-content></ng-content>
    <div class="glxy-page-nav-overlay" *ngIf="mobileQuery.matches" (click)="togglePageNav()"></div>
  </mat-sidenav-content>
</mat-sidenav-container>
